function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(0 -11.714)"
}, React.createElement("path", {
  className: "a",
  d: "M20.378,18.387,15,18a.288.288,0,0,1-.252-.184L12.7,12.828a1.8,1.8,0,0,0-3.334,0L7.309,17.826a.3.3,0,0,1-.252.184l-5.37.386A1.776,1.776,0,0,0,.1,19.614,1.761,1.761,0,0,0,.636,21.56l4.157,3.433a.3.3,0,0,1,.1.3L3.624,30.476a1.753,1.753,0,0,0,.283,1.532,1.792,1.792,0,0,0,1.416.706,1.707,1.707,0,0,0,.948-.288L10.815,29.6a.3.3,0,0,1,.31,0l4.588,2.818a1.718,1.718,0,0,0,.957.3,1.763,1.763,0,0,0,1.362-.665,1.821,1.821,0,0,0,.346-1.555l-1.272-5.2a.3.3,0,0,1,.1-.3l4.22-3.442a1.8,1.8,0,0,0-1.047-3.164Zm.346,2.314L16.513,24.14a1.4,1.4,0,0,0-.472,1.416l1.272,5.19a.71.71,0,0,1-.135.616.662.662,0,0,1-.5.256.627.627,0,0,1-.36-.121l-4.606-2.831a1.4,1.4,0,0,0-.733-.207,1.378,1.378,0,0,0-.737.211L5.678,31.505a.667.667,0,0,1-.89-.162.638.638,0,0,1-.094-.589l1.272-5.2A1.4,1.4,0,0,0,5.5,24.144L1.35,20.715a.7.7,0,0,1,.413-1.222l5.379-.386a1.392,1.392,0,0,0,1.191-.863l2.054-4.993a.7.7,0,0,1,1.294,0l2.054,4.993a1.392,1.392,0,0,0,1.191.863l5.388.391a.677.677,0,0,1,.607.472A.693.693,0,0,1,20.724,20.7Z",
  transform: "translate(0)"
}));

var SvgStar = function SvgStar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 22.053,
    height: 21,
    viewBox: "0 0 22.053 21",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgStar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/star.43cc85a9.svg";
export { ForwardRef as ReactComponent };